module.exports = __webpack_public_path__ + "img/product_29.c3ab55f.webp";